// export const API = 'http://localhost:8000/api';
export const API = 'https://topkids-center.ru/api';
export const API_ORDER = API+'/service/order-mail-fr/'